import {
  type AxiosRequestConfig,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { Rating } from './ahafood/get-store-fn';
import { apiRoutes } from './api-routes';

export interface GetSoloMealItemParams {
  skip?: number;
  lat: number;
  lng: number;
  limit: number;
  category?: string;
}

export interface SoloMealItemResponse {
  solo_meal_items: SoloMealItem[];
}

export interface SoloMealItem {
  _id: number;
  name: string;
  image_thumb_url: string;
  price: number;
  discounted_price: number;
  store_id: number;
  item_total_sold: number;
  store_total_sold: number;
  rating: Rating;
  store_slug: string;
  store_name: string;
  distance: number;
  is_available: boolean;
  is_temporary_closed?: boolean;
  image_preview_url?: string;
  trend_item?: boolean;
  is_ai_image?: boolean;
  solo_meal_video_url?: string;
}

export const getSoloMealItemFn = async (
  params: GetSoloMealItemParams,
  config: AxiosRequestConfig = {},
  token?: string
): Promise<SoloMealItemResponse> => {
  const url = apiRoutes.ahafood.store.get_solomeal_item;

  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await publicHttpClient.get<SoloMealItemResponse>(url, {
    params,
    ...config,
    headers: {
      ...headers,
      ...config.headers,
    },
  });

  return response?.data;
};

export const useGetSoloMealItem = (
  params: GetSoloMealItemParams,
  token?: string,
  opts?: Omit<
    UseQueryOptions<SoloMealItemResponse, Error>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<SoloMealItemResponse, Error>({
    queryKey: [apiRoutes.ahafood.store.get_solomeal_item, params, token],
    queryFn: () => getSoloMealItemFn(params, {}, token),
    ...opts,
  });
};
